import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://taimudaojia.cn/api/search-image?query=Elegant%20abstract%20geometric%20composition%20with%20flowing%20warm%20gradients%20of%20amber%20and%20cream%2C%20soft%20organic%20shapes%20overlapping%20on%20a%20light%20minimalist%20background%2C%20modern%20editorial%20aesthetic%2C%20Asian%20art%20influence%20with%20ink%20wash%20textures%2C%20serene%20and%20sophisticated%20atmosphere%2C%20high-end%20brand%20visual%20identity&width=1800&height=900&seq=hero-bg-main-2026&orientation=landscape"
          alt="亚洲精品一区二区 - 精选内容分区导览"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <i className="ri-sparkling-line text-primary-300 text-sm"></i>
          <span className="text-background-50 text-sm font-medium">2026 年度精选内容全新上线</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          亚洲精品一区二区
          <br />
          <span className="text-primary-300">精选内容分区导览</span>
        </h1>

        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          为您提供专业分区内容导览，涵盖一区精品推荐与二区优质资源，
          精准分类、快速定位，满足您对亚洲精品内容的多样化需求。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zone1"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-star-line mr-2"></i>
            探索一区精品
          </Link>
          <Link
            to="/category/zone2"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-stack-line mr-2"></i>
            浏览二区资源
          </Link>
        </div>
      </div>
    </section>
  );
}